import React from 'react'
import * as Comp from './input-password-field.styles'

import type {
  NativeSyntheticEvent,
  TextInput,
  TextInputFocusEventData,
} from 'react-native'
import { useInputPasswordProps } from '../../hooks'
import type { IInputPasswordProps } from '../../types'

export const InputPasswordField = React.forwardRef<
  TextInput,
  IInputPasswordProps
>(({ onFocus, ...props }, ref) => {
  const {
    id,
    size,
    inputValue,
    disabled,
    readonly,
    isActive,
    setIsActive,
    isHidden,
    onChangeText,
  } = useInputPasswordProps()

  const handleFocus = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    setIsActive(true)
  }

  const handleBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    setIsActive(false)
  }

  const isDisabled = disabled || readonly
  const isEditable = !isDisabled || !readonly

  return (
    <Comp.Field
      {...props}
      ref={ref}
      size={size}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChangeText={onChangeText}
      value={inputValue}
      aria-label={id}
      nativeID={id}
      cursorColor="black"
      editable={isDisabled ? false : isEditable}
      secureTextEntry={isHidden}
      disabled={isDisabled}
      readonly={readonly}
      isActive={isActive}
      numberOfLines={1}
    />
  )
})
